function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M487.3,361.1L372.2,246l46.3-46.3l64.3-64.4c17.6-17.6,17.6-46.1,0-63.7l-42.4-42.4 c-8.8-8.8-20.3-13.2-31.9-13.2c-11.5,0-23.1,4.4-31.9,13.2l-64.3,64.3L266,139.8L150.9,24.7c-5.8-5.8-13.4-8.7-21.1-8.7 s-15.2,2.9-21,8.7l-84.1,84.1c-11.6,11.6-11.6,30.5,0,42.1L139.9,266L33.9,372L16.3,472.7c-2.5,14.6,10.5,25.2,23.1,23.1l100.7-17.6 l105.8-105.9L361,487.3c5.5,5.6,13.1,8.7,21,8.7c7.6,0,15.2-2.9,21-8.7l84.1-84.1C498.9,391.6,498.9,372.7,487.3,361.1L487.3,361.1z  M397.9,50.4c3.8-3.8,17.4-3.8,21.3,0l42.4,42.4c5.8,5.8,5.8,15.4,0,21.3l-43.1,43.1l-63.7-63.7C354.7,93.5,397.9,50.4,397.9,50.4z  M45.9,130l83.9-83.9l52.5,52.4l-36.6,36.6c-2.9,2.9-2.9,7.7,0,10.6l10.6,10.6c2.9,2.9,7.7,2.9,10.6,0l36.6-36.6l41.3,41.2 L161,244.8L45.9,130z M125.6,450.2l-77.2,13.6l13.5-77.2l271.7-271.7l63.7,63.7L125.6,450.2L125.6,450.2z M382.4,466.1L267.2,351 l83.9-83.9l41.3,41.3l-36.7,36.7c-2.9,2.9-2.9,7.7,0,10.6l10.6,10.6c2.9,2.9,7.7,2.9,10.6,0l36.7-36.8l52.4,52.4L382.4,466.1z"
});

var SvgIconDraftOrders = function SvgIconDraftOrders(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconDraftOrders, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_draft_orders.a3512c5c.svg";
export { ForwardRef as ReactComponent };